<div class="text-activity-wrapper">
  @if (gettingGame) {
    <ebs-spinner [spinnerMessage]="'loading..'" [faColour]="'#999'" [boxColour]="'#999'" [faFont]="'2.2rem'"
    [boxFont]="'1.2rem'" [boxPadding]="'5%'"></ebs-spinner>
  }

  @if (!gettingGame) {
    <div>
      <div class="card-body">
        @if (activityItem.gameName=='EBSDemo') {
          <div>
            <ebs-webgl-demo [gameConfiguration] = "activityItem.gameConfiguration"></ebs-webgl-demo>
          </div>
        }
        @if (activityItem.gameName=='WebVR') {
          <div>
            <ebs-webvr-demo [gameConfiguration] = "activityItem.gameConfiguration"></ebs-webvr-demo>
          </div>
        }
        @if (activityItem.gameName=='Supermarket') {
          <div>
            <ebs-supermarket-game [gameConfiguration] = "activityItem.gameConfiguration"></ebs-supermarket-game>
          </div>
        }
      </div>
    </div>
  }
</div>